export const SITUACAO_PAGAMENTO = {
    AGUARDANDO: 1,
    PAGO: 2,
    VENCIDO: 3,
    CANCELADO: 4,
};

const SITUACAO_POR_NOME = {
    AguardandoPagamento: SITUACAO_PAGAMENTO.AGUARDANDO,
    Pago: SITUACAO_PAGAMENTO.PAGO,
    Vencido: SITUACAO_PAGAMENTO.VENCIDO,
    Cancelado: SITUACAO_PAGAMENTO.CANCELADO,
};

export function obterSituacaoPagamentoNumerica(pagamento) {
    if (!pagamento || pagamento.situacao === null || pagamento.situacao === undefined) return null;

    const { situacao } = pagamento;
    if (typeof situacao === 'number') return situacao;
    if (typeof situacao === 'string') {
        if (SITUACAO_POR_NOME[situacao] !== undefined) return SITUACAO_POR_NOME[situacao];
        const convertido = Number(situacao);
        return Number.isNaN(convertido) ? null : convertido;
    }
    return null;
}

export function pagamentoEstaPago(pagamento) {
    if (!pagamento) return false;
    const situacaoNumerica = obterSituacaoPagamentoNumerica(pagamento);
    return situacaoNumerica === SITUACAO_PAGAMENTO.PAGO;
}

export function chavePagamentoSinalizado(inscricaoId) {
    return `pnc-pagamento-sinalizado-${inscricaoId}`;
}

export function pagamentoFoiSinalizadoPeloCandidato(inscricaoId) {
    if (!inscricaoId) return false;
    return localStorage.getItem(chavePagamentoSinalizado(inscricaoId)) === 'true';
}

export function registrarSinalizacaoPagamento(inscricaoId) {
    if (!inscricaoId) return;
    localStorage.setItem(chavePagamentoSinalizado(inscricaoId), 'true');
}

export function limparSinalizacaoPagamento(inscricaoId) {
    if (!inscricaoId) return;
    localStorage.removeItem(chavePagamentoSinalizado(inscricaoId));
}
